import { render, staticRenderFns } from "./GameComponent.vue?vue&type=template&id=ea8d6ab6&scoped=true&"
import script from "./GameComponent.vue?vue&type=script&lang=js&"
export * from "./GameComponent.vue?vue&type=script&lang=js&"
import style0 from "./GameComponent.vue?vue&type=style&index=0&id=ea8d6ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8d6ab6",
  null
  
)

export default component.exports